import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "summary-grid",
	templateUrl: "./summary-grid.component.html",
	styleUrls: ["./summary-grid.component.scss"],
	standalone: false
})
export class SummaryGridComponent {
	@Output()
	public onStepClick = new EventEmitter<number>();

	@Input() public step: number;

	@Input() public cssGrayOut: boolean = false;
	@Input() public cssHover: boolean = false;
	@Input() public cssFaded: boolean = false;

	@Input() public titleKey: string = "";

	public stepClick(n: number): void {
		this.onStepClick.emit(n);
	}
}
